// ─────────────────────────────────────────────────────────────
//  HEROESBEND HOTEL — Central room data
//  Single source of truth used by Home, Rooms, Footer, Booking,
//  Contact, FAQ and Checkout so pricing stays consistent.
// ─────────────────────────────────────────────────────────────

export const rooms = [
  {
    id: 'r1',
    tag: 'Classic',
    title: 'Classic Room',
    price: 30000,
    color: '#2d7a4f',
    img: '/images/hb/rooms/room-classic.jpg',
    type: 'room',
    persons: '1–2',
    size: '240 sq ft',
    desc: 'A comfortable, tastefully furnished room with a queen-size bed, en-suite shower, air-conditioning, Smart TV and complimentary WiFi — ideal for the value-conscious traveller.',
    features: ['Queen Size Bed', 'En-Suite Bathroom', 'Air Conditioning', 'Smart TV', 'Free WiFi', '24h Power'],
  },
  {
    id: 'r2',
    tag: 'Standard',
    title: 'Standard Room',
    price: 40000,
    color: '#1565c0',
    img: '/images/hb/rooms/room-standard.jpg',
    type: 'room',
    persons: '1–2',
    size: '280 sq ft',
    desc: 'A well-appointed room with a queen-size bed, work desk, en-suite bathroom and all the essentials for a relaxing, productive stay.',
    features: ['Queen Size Bed', 'Work Desk', 'En-Suite Bathroom', 'Air Conditioning', 'Smart TV', 'Free WiFi'],
  },
  {
    id: 'r3',
    tag: 'Deluxe',
    title: 'Deluxe Room',
    price: 50000,
    color: '#00838f',
    img: '/images/hb/rooms/room-deluxe.jpg',
    type: 'room',
    persons: '1–2',
    size: '340 sq ft',
    desc: 'Spacious and elegant with a king-size bed, premium en-suite with hot water, a seating nook and Smart TV. Complimentary breakfast included.',
    features: ['King Size Bed', 'Premium En-Suite', 'Seating Nook', 'Air Conditioning', 'Smart TV', 'Complimentary Breakfast'],
  },
  {
    id: 'r4',
    tag: 'Premium',
    title: 'Premium Room',
    price: 60000,
    color: '#6a1b9a',
    img: '/images/hb/rooms/room-premium.jpg',
    type: 'room',
    persons: '1–2',
    size: '400 sq ft',
    desc: 'Upgraded comfort with a king-size bed, larger workspace, premium bathroom, mini-bar and city views. Breakfast included.',
    features: ['King Size Bed', 'Mini Bar', 'Premium Bathroom', 'Work Desk', 'City View', 'Complimentary Breakfast'],
  },
  {
    id: 'r5',
    tag: 'Executive',
    title: 'Executive Room',
    price: 70000,
    color: '#c62828',
    img: '/images/hb/rooms/room-executive.jpg',
    type: 'room',
    persons: '1–3',
    size: '480 sq ft',
    desc: 'A generous executive room with a king-size bed, dedicated sitting area, premium bathroom and full business amenities for the discerning guest.',
    features: ['King Size Bed', 'Sitting Area', 'Premium Bathroom', 'Work Desk', 'Room Service', 'Complimentary Breakfast'],
  },
  {
    id: 'r6',
    tag: 'Exec Suite',
    title: 'Executive Suite',
    price: 100000,
    color: '#ad1457',
    img: '/images/hb/rooms/suite-executive.jpg',
    type: 'room',
    persons: '1–3',
    size: '640 sq ft',
    desc: 'A refined suite with a separate living room, king-size bedroom, luxury bathroom and premium furnishings — perfect for extended or business stays.',
    features: ['King Bedroom', 'Separate Living Room', 'Luxury Bathroom', 'Mini Bar', 'Room Service', 'Complimentary Breakfast'],
  },
  {
    id: 'r7',
    tag: 'Luxury',
    title: 'Luxury Suite',
    price: 120000,
    color: '#b08d57',
    img: '/images/hb/rooms/suite-luxury.jpg',
    type: 'room',
    persons: '1–4',
    size: '820 sq ft',
    desc: 'The pinnacle of Heroesbend luxury — a grand living room, opulent king bedroom, spa-style bathroom, dedicated butler service and panoramic views.',
    features: ['King Bedroom', 'Grand Living Room', 'Spa Bathroom', 'Dedicated Butler', 'Mini Bar', 'Room Service'],
  },
];

// Convenience label list, e.g. "Classic Room — ₦30,000/night"
export const roomOptions = rooms.map(
  (r) => `${r.title} — ₦${r.price.toLocaleString()}/night`
);

export default rooms;
